import { SubscribersFilters } from './types';
import { FilterOption } from '../../../components/ui';

export const DEFAULT_FILTERS: SubscribersFilters = {
  search: '',
  campaignId: null,
  account: 'all',
  paymentTypes: [],
  models: [],
  accounts: [],
  model_id: null,
};

export const DEFAULT_PAGE_SIZE = 10;
export const SEARCH_DEBOUNCE_DELAY = 500;
export const MODELS_PAGE_SIZE = 20;
export const MODEL_SEARCH_DEBOUNCE_DELAY = 300;

export const getPaymentTypes = (t: (key: string) => string) => [
  { key: 'has_gte_three_messages', label: t('subscribers.paymentTypes.threeMessages') },
  { key: 'one_transaction', label: t('subscribers.paymentTypes.onePayment') },
  { key: 'two_transaction', label: t('subscribers.paymentTypes.twoPayments') },
  { key: 'five_transaction', label: t('subscribers.paymentTypes.fivePayments') },
  { key: 'amount_more_500', label: t('subscribers.paymentTypes.payment500') },
  { key: 'paid_subscription', label: t('subscribers.paymentTypes.paidSubscription') },
  { key: 'free_subscription', label: t('subscribers.paymentTypes.freeSubscription') },
];

export const getAccountOptions = (t: (key: string) => string) => [
  { key: 'all', label: t('subscribers.accountOptions.allAccounts') },
  { key: 'account1', label: t('subscribers.accountOptions.account1') },
  { key: 'account2', label: t('subscribers.accountOptions.account2') },
];

export const getTableColumns = (t: (key: string) => string) => [
  { key: 'id', name: t('subscribers.table.columns.id') },
  { key: 'campaign', name: t('subscribers.table.columns.campaign') },
  { key: 'user', name: t('subscribers.table.columns.user') },
  {
    key: 'createdAt',
    name: t('subscribers.table.columns.createdAt'),
    sortable: true,
    sortKey: 'created_at',
  },
];

// Статические константы (остаются как есть)
export const PAYMENT_TYPES = [
  { key: '1-payment', label: '1 payment' },
  { key: '2-payments', label: '2 payments' },
  { key: '5-payments', label: '5 payments' },
  { key: 'payment-500', label: 'Payments $500' },
  { key: '3-messages', label: '3 messages' },
];

export const ACCOUNT_OPTIONS = [
  { key: 'all', label: 'All accounts' },
  { key: 'account1', label: 'Account 1' },
  { key: 'account2', label: 'Account 2' },
];

export const TABLE_COLUMNS = [
  { key: 'id', name: 'ID' },
  { key: 'campaign', name: 'Campaign' },
  { key: 'user', name: 'User' },
  { key: 'createdAt', name: 'Subscription Date' },
];
